module.exports = __webpack_public_path__ + "static/media/logout-focused.0b6d2eac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/logout-focused.svg
// module id = 1223
// module chunks = 0